import React from "react"

interface Props {
    children: React.ReactNode
}

export function ListBottomNews({ children }: Props) {
    return (
        <div className='w-full h-auto mt-4 mb-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
            {children}
        </div>
    )
}